export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = 4